import React from 'react';
import { StaffMembersDataHooks } from './dataHooks';
import { TagName } from '../../../../utils/tagName.const';
import { StaffMember } from '@wix/bookings-uou-types';
import Text, { TextType } from '../../Text/Text';
import { TFunction, useTranslation } from '@wix/yoshi-flow-editor';
import { FormService } from '../../../../utils/mappers/serviceMapper/service.mapper';
import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
import {
  RequestedGender,
  ResourceSelection,
  SelectionMethod,
} from '@wix/ambassador-bookings-v2-booking/types';
import { STAFF_RESOURCE_TYPE_ID } from '../../../../consts/resource';

const ANY_STAFF_KEY = 'app.bookings-form.appointment-details.first-available';

const ANY_GENDER_STAFF_KEYS: Partial<Record<RequestedGender, string>> = {
  [RequestedGender.ANY_FEMALE]:
    'app.bookings-form.appointment-details.any-female-staff',
  [RequestedGender.ANY_MALE]:
    'app.bookings-form.appointment-details.any-male-staff',
};

export interface StaffMembersProps {
  service: FormService;
  resourceSelections?: ResourceSelection[];
}

const StaffMembers: React.FC<StaffMembersProps> = ({
  service,
  resourceSelections,
}) => {
  const { t } = useTranslation();
  const staffMemberNames = getStaffMembers(service, t, resourceSelections);

  return (
    <Text
      type={TextType.Secondary}
      data-hook={StaffMembersDataHooks.STAFF_MEMBER}
      tagName={TagName.Paragraph}
    >
      {staffMemberNames}
    </Text>
  );
};

const getStaffMembers = (
  service: FormService,
  t: TFunction,
  resourceSelections?: ResourceSelection[],
) => {
  const staffMembers: StaffMember[] = service.staffMembers || [];

  if (staffMembers.length || service.type !== ServiceType.APPOINTMENT) {
    return staffMembers.map((staffMember) => staffMember.name).join(', ');
  }

  const staffSelection = resourceSelections?.find(
    ({ resourceTypeId }) => resourceTypeId === STAFF_RESOURCE_TYPE_ID,
  );

  if (staffSelection?.selectionMethod === SelectionMethod.ANY_RESOURCE) {
    const requestedGender = staffSelection.requestedGender?.gender;

    return t(
      (requestedGender && ANY_GENDER_STAFF_KEYS[requestedGender]) ??
        ANY_STAFF_KEY,
    );
  }

  return '';
};

export default StaffMembers;
